import Vue from 'vue';
import Component from 'vue-class-component';
import BScroll from 'better-scroll';
import load from '@/assets/images/upLoading.gif';
import { postForm } from '../../../utils/CrmHttp';
import { TransferInStateEnum } from '@/types/crm-enums';

@Component({
})

export default class DrawMoneyRecord extends Vue {
  /*
   * 充值记录
   */
  public loading: boolean = false;
  public refer: string = '下拉刷新';
  public referMeg: string = '已刷新';
  public msgShow: boolean = false;
  public UpLoad: string = '上拉加载更多';
  public uploadHint: boolean = true;
  public referHint: boolean = true;
  public listLength: any = '0';
  public load = load;
  public flage: boolean = true;
  public datas: any[] = [];
  public async created() {
    //
  }
  public async getData(start, end, flage) {
    try {
      const data =
        await postForm('/api/transfer-in/query', {
          Start: start,
          Limit: end,
        });
      if (flage) {
        this.datas = [];
      }
      if (data.Data.length === 0) {
        this.UpLoad = '没有更多数据';
        return;
      }
      for (const i of data.Data) {
        const obj = {};
        for (const a in i) {
          obj[a] = i[a];
        }
        this.datas.push(obj);
      }
      this.listLength = this.datas.length;
      this.referMeg = '已刷新';
    } catch (e) {
      this.referMeg = '刷新失败';
      console.error(e);
    }
  }
  public activated() {

    this.loading = true;
    this.datas = [];
    this.getData(0, 20, true)
      .then(() => this.loading = false)
      .catch(() => this.loading = false);
    this.refer = '下拉刷新';
    this.$nextTick(() => {
      if (!this.scroll) {
        const wrapper = this.$refs.wrapper;
        let heig = this.$refs.fristD.offsetHeight;
        let heig2 = this.$refs.wrapper.offsetHeight -
          this.$refs.list.offsetHeight;
        this.scroll = new BScroll(wrapper, {
          startY: -heig,
          click: true,
          scrollY: true,
          probeType: 3,
        });
        this.scroll.on('scroll', (req) => {
          if (req.y > -heig - 5 || req.y < heig2) {
            // console.log('到 顶/低 停')
            if (this.flage) {
              this.scroll.stop();
              this.flage = false;
            }
          } else {
            this.flage = true;
            this.refer = '下拉刷新';
            this.UpLoad = '上拉加载更多记录';
          }

          if (req.y - 20 > 0) {
            if (this.referHint) {
              this.refer = '松开立即刷新';
            }
          } else if (req.y < heig2 - 20 && heig2 < 0) {
            if (this.uploadHint) {
              this.UpLoad = '松开立即加载';
            }
          }
        });
        this.scroll.on('touchEnd', async (req) => {
          if (req.y > 0) {
            this.referHint = false;
            this.refer = '正在刷新.....';
            this.flage = true;
            this.scroll.scrollTo(0, 0, 100);
            await this.getData(0, 20, true);
            this.flage = false;
            this.msgShow = true;
            setTimeout(() => {
              this.msgShow = false;
            }, 2000);
            this.refer = '下拉刷新';
            this.referHint = true;
            setTimeout(() => {
              this.scroll.scrollTo(0, -heig, 100);
            }, 1)
          } else if (req.y > -heig && req.y < 0) {
            setTimeout(() => {
              this.scroll.scrollTo(0, -heig, 100);
            }, 1)
          } else if (req.y < heig2 - 20 && heig2 < 0) {
            this.uploadHint = false;
            this.UpLoad = '正在加载.....';
            this.flage = true;
            this.scroll.scrollTo(0, heig2, 100);
            await this.getData(this.listLength, 10, false);
            if (this.UpLoad != '没有更多数据') {
              this.UpLoad = '上拉加载更多记录';
            }
            this.uploadHint = true;
            // 重新计算滚动区域
            this.scroll.refresh();
          }
          heig = this.$refs.fristD.offsetHeight;
          heig2 = this.$refs.wrapper.offsetHeight -
            this.$refs.list.offsetHeight;
          this.scroll.stop();
        });
      } else {
        this.scroll.refresh();
      }
    });
  }
  // 点击列表, 查看详细信息
  public handleMessage(item: TransferInModel, index) {
    this.$router.push({
      path: '/details',
      name: 'details',
      params: Object.assign({}, item) as any,
    });
  }
  // 返回
  public goback() {
    this.$router.go(-1);
  }
  public realMoney(item: TransferInModel) {
    switch (item.State) {
      case TransferInStateEnum.Accept:
      case TransferInStateEnum.PaySuc:
        return item.Money;
      default:
        return item.StateStr;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Person/RechargeRecord/RechargeRecord.ts